export default "__VITE_ASSET__5J9QK3rq__"